export default __webpack_public_path__ + "static/media/uajy-logo.6bf5e1e3.png";